<template>
  <div>
    <content-placeholder v-if="loading">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else>
      <div slot="header">PTO Availability</div>
      <div slot="actions"><el-button @click="handleAddNew">Add New Year</el-button></div>
      <div v-loading="processing">
        <div v-if="loadError">
          <error-block :buttonCallback="fetchPtoAvailabilities" />
        </div>
        <div v-else>
          <div v-if="ptoAvailabilities.length">
            <el-tabs :value="selectedTab" @tab-click="handleTabClick">
              <el-tab-pane v-for="(objects, year) in groupedPtoAvailabilities" :label="year" :name="year" :key="year">
                <pto-availability-item :userId="userId" :year="year" :ptoAvailabilities="objects" />
              </el-tab-pane>
            </el-tabs>
          </div>
          <div v-else>
            <el-alert
              title="No PTOs found!"
              type="info"
              center
              :closable="false">
            </el-alert>
          </div>
        </div>
      </div>
    </el-card>

    <pto-availability-form-modal :onSuccess="handleAvailabilityCreated" v-if="formModalOpened" />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { groupBy } from 'lodash';

  import PtoAvailabilityFormModal from '@/components/ptoAvailability/PtoAvailabilityFormModal';
  import PtoAvailabilityItem from '@/components/ptoAvailability/PtoAvailabilityItem';

  export default {
    name: 'PtoAvailability',
    props: {
      userId: {
        required: true,
        type: Number,
      },
    },
    components: {
      ptoAvailabilityFormModal: PtoAvailabilityFormModal,
      ptoAvailabilityItem: PtoAvailabilityItem,
    },
    created() {
      this.fetchPtoAvailabilities();
    },
    data() {
      return {
        loading: true,
        processing: false,
        loadError: null,
      };
    },
    computed: {
      ...mapGetters('entities/ptoAvailabilities', ['formModalOpened']),

      ptoAvailabilities() {
        return this.$store.getters['entities/ptoAvailabilities/query']()
          .with('category')
          .with('author')
          .where('user_id', this.userId)
          .get();
      },

      groupedPtoAvailabilities() {
        return groupBy(this.ptoAvailabilities, o => o.year);
      },

      selectedTab() {
        return this.ptoAvailabilities.length ? `${this.ptoAvailabilities[0].year}` : '';
      },

    },
    methods: {
      ...mapActions('entities/ptoAvailabilities', ['openFormModal']),
      ...mapActions('entities/ptos', ['fetchPtos']),

      fetchPtoAvailabilities() {
        this.loadError = null;
        this.loading = true;
        return this.$store.dispatch('entities/ptoAvailabilities/fetchPtoAvailabilities', { userId: this.userId })
          .then((response) => {
            if (!response.status) {
              this.loadError = response.error;
            }

            this.loading = false;
          });
      },

      handleAddNew() {
        this.openFormModal({ user_id: this.userId });
      },

      handleTabClick(tab) {
        this.processing = true;
        this.loadError = null;
        this.fetchPtos({ year: tab.name })
          .then((response) => {
            if (!response.status) {
              this.loadError = response.error;
            }

            this.processing = false;
          });
      },

      handleAvailabilityCreated() {
        this.processing = true;
        this.loadError = null;
        this.fetchPtoAvailabilities()
          .then(() => {
            // if (!response.status) {
            //   this.loadError = response.error;
            // }

            this.processing = false;
          });
      },

    },
  };
</script>


// WEBPACK FOOTER //
// src/components/ptoAvailability/PtoAvailability.vue